import { useState, useRef, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios"; // Pastikan axios terimport
import {
  FiHome,
  FiCheckSquare,
  FiCalendar,
  FiBarChart2,
  FiUser,
  FiLogOut,
  FiClipboard,
  FiMoreHorizontal,
  FiBookOpen,
  FiBell, // Import icon lonceng
} from "react-icons/fi";
import { AuthContext } from "../../context/AuthContext";

const sidebarItems = [
  { to: "/guru", label: "Beranda", icon: FiHome },
  { to: "/guru/presensi", label: "Presensi", icon: FiCheckSquare },
  { to: "/guru/jadwal", label: "Jadwal", icon: FiCalendar },
  { to: "/guru/monitoring", label: "Monitoring Kehadiran", icon: FiClipboard },
  { to: "/guru/rekapitulasi", label: "Rekapitulasi", icon: FiBarChart2 },
  { to: "/guru/profil", label: "Profil", icon: FiUser },
];

export default function GuruLayout({ children }) {
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0); // State untuk angka notifikasi

  const dropdownRef = useRef(null);
  const location = useLocation();
  const { logout } = useContext(AuthContext);

  // Logic fetch notifikasi (Tanpa merubah logic lain)
  useEffect(() => {
    const fetchNotif = async () => {
      try {
        const response = await axios.get("https://backend.smpn1kamal.sch.id/api/pengganti/notifikasi-kosong");
        setNotifCount(response.data.total);
      } catch (err) {
        console.error("Gagal mengambil notifikasi");
      }
    };
    fetchNotif();
  }, []);

  const handleLogout = () => {
    setOpen(false);
    setDropdownOpen(false);
    logout();
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="min-h-screen bg-slate-100">
      
      {/* SIDEBAR - Tetap Sama */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 w-64 bg-white shadow-lg transform transition-transform duration-300 ${
          open ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
      >
        <div className="px-6 py-5 flex items-center gap-3">
          <img src="/logo.png" alt="Logo" className="w-9 h-9 object-contain" />
          <h1 className="font-bold text-xl text-blue-700">SIPENSA</h1>
        </div>

        <nav className="px-4 flex flex-col h-[calc(100vh-80px)]">
          <div className="space-y-1">
            {sidebarItems.map((item) => {
              const isDashboard = item.to === "/guru";
              const active = isDashboard
                ? location.pathname === "/guru"
                : location.pathname.startsWith(item.to);

              return (
                <SidebarItem
                  key={item.to}
                  to={item.to}
                  icon={item.icon}
                  label={item.label}
                  active={active}
                  onClick={() => setOpen(false)}
                />
              );
            })}
          </div>

          <div className="mt-auto px-4 py-4 border-t border-slate-200">
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 transition"
            >
              <FiLogOut className="text-lg" />
              Keluar
            </button>
          </div>
        </nav>
      </aside>

      {/* OVERLAY MOBILE */}
      {open && (
        <div className="fixed inset-0 bg-black/40 z-30 md:hidden" onClick={() => setOpen(false)} />
      )}

      {/* CONTENT */}
      <div className="flex flex-col min-h-screen md:ml-64">
        <header className="bg-white shadow-sm px-6 py-4 flex items-center justify-between sticky top-0 z-40">
          
          <div className="flex items-center gap-4">
            <button className="md:hidden text-xl" onClick={() => setOpen(!open)}>
              ☰
            </button>

            <p className="font-semibold text-lg">
              Selamat Datang,{" "}
              <span className="text-blue-600">Guru</span> 👋
            </p>
          </div>

          {/* Wrapper untuk icon Notifikasi dan Titik Tiga */}
          <div className="flex items-center gap-4">
            
            {/* NOTIFIKASI GURU KOSONG */}
            <Link to="/guru/jadwal-kosong" className="relative text-slate-600 hover:text-blue-600 transition p-1">
              <FiBell className="text-xl" />
              {notifCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white ring-1 ring-white">
                  {notifCount}
                </span>
              )}
            </Link>

            {/* DROPDOWN TITIK TIGA */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="text-slate-600 hover:text-blue-600 transition flex items-center"
              >
                <FiMoreHorizontal className="text-xl" />
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 top-9 w-44 bg-white border border-slate-200 rounded-xl shadow-lg overflow-hidden z-50">
                  <Link to="/guru/petunjuk" onClick={() => setDropdownOpen(false)} className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                    <FiBookOpen className="text-base text-slate-400" /> Petunjuk
                  </Link>
                  <Link to="/guru/presensi" onClick={() => setDropdownOpen(false)} className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                    <FiCheckSquare className="text-base text-slate-400" /> Presensi
                  </Link>
                  <Link to="/guru/profil" onClick={() => setDropdownOpen(false)} className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                    <FiUser className="text-base text-slate-400" /> Profil
                  </Link>
                  <div className="border-t border-slate-100 my-1" />
                  <button onClick={handleLogout} className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors">
                    <FiLogOut className="text-base" /> Keluar
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        <main className="p-4 md:p-6 bg-slate-100 flex-1">
          {children}
        </main>
      </div>
    </div>
  );
}

/* SIDEBAR ITEM - Tetap Sama */
function SidebarItem({ to, icon: Icon, label, active, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`flex items-center gap-3 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200
        ${active ? "bg-blue-100 text-blue-700" : "text-slate-600 hover:bg-blue-50 hover:text-blue-600"}`}
    >
      {Icon && <Icon className="text-lg" />}
      {label}
    </Link>
  );
}